var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _vm.shows ? _c('vue-draggable-resizable', _vm._g(_vm._b({
    key: _vm.key,
    ref: "node-area",
    on: {
      "dragstop": _vm.emit,
      "resizestop": _vm.emit
    }
  }, 'vue-draggable-resizable', _vm.props_node, false), {
    activated: _vm.activated,
    deactivated: _vm.deactivated,
    dragging: _vm.dragging,
    resizing: _vm.resizing
  }), [_c('div', {
    staticClass: "fill-height",
    staticStyle: {
      "position": "relative"
    },
    on: {
      "click": function ($event) {
        $event.stopPropagation();
      }
    }
  }, [_c('node-area-wrap', [_c('node-area-back', _vm._b({}, 'node-area-back', {
    value: _vm.value,
    mode: _vm.mode
  }, false)), _c('node-area-icon', _vm._b({}, 'node-area-icon', {
    value: _vm.value,
    mode: _vm.mode
  }, false)), _vm._t("default"), _c('node-area-edit', _vm._b({}, 'node-area-edit', {
    mode: _vm.mode,
    active: _vm.active
  }, false))], 2)], 1)]) : _vm._e();

}
var staticRenderFns = []

export { render, staticRenderFns }